import { getAbsolutePath, ORDER_ROUTES } from '../routes';

export function getAddToCartRedirectUrl() {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return getAbsolutePath('ORDER_STEPS', ORDER_ROUTES);
}
